module.exports = __webpack_public_path__ + "static/media/navidad.2ececc13.webp";